import React, { useMemo } from "react";
import styled from "styled-components";
import Cart from "./cart";
import { SelectedPackage } from "types/promoType";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import PrimaryButton from "components/buttons/primary-button";
import LinkText from "components/typography/linkText";

interface IProps {
  cartItems: SelectedPackage[];
  removeCartItem: (pkg: SelectedPackage) => void;
  clearCart: () => void;
}
const StepFour = ({ cartItems, removeCartItem, clearCart }: IProps) => {
  const totalPrice = useMemo(() => {
    const total = cartItems.reduce(
      (total, item) => total + Number(item.packagePrice),
      0
    );
    return total;
  }, [cartItems]);

  console.log(cartItems);
  return (
    <Container>
      <Cart
        cartItems={cartItems}
        removeCartItem={(pkg) => removeCartItem(pkg)}
        clearCart={() => clearCart()}
      />
      <GrayCard fullWidth title="Order Summary">
        <SummaryItems>
          <SummaryItem>
            <Typography color={Colors.grey500}>
              Item’s Total ({cartItems.length})
            </Typography>
            <Typography>${totalPrice}</Typography>
          </SummaryItem>
          <SummaryItem>
            <Typography color={Colors.grey500}>Fees</Typography>
            <Typography>$20</Typography>
          </SummaryItem>
          <SummaryItem style={{ marginTop: "0.8rem" }}>
            <Typography>Total</Typography>
            <Typography>${totalPrice + 20}</Typography>
          </SummaryItem>
        </SummaryItems>
        <ButtonContainer>
          <PrimaryButton text="Proceed to Payment" />
        </ButtonContainer>
        <span style={{ textAlign: "center" }}>
          <Typography align="center">
            By proceeding, you are automatically accepting Rated Afrika’s
          </Typography>
          <LinkText
            to="/terms"
            text="Terms &
        Conditions"
            color="white"
          />
        </span>
      </GrayCard>
    </Container>
  );
};

export default StepFour;

const Container = styled.div`
  display: grid;
  grid-template-columns: 65% 35%;
  gap: 3rem;
  max-height: 70dvh;

  @media only screen and (max-width: 769px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

const SummaryItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ButtonContainer = styled.div`
  margin: 2rem 0;
`;
